import GoodPracticeCategorisation from 'components/GoodPracticeCategorisation/components/GoodPracticeCategorisation';
import GoodPracticeDetails from 'components/GoodPracticeDetails';
import { NewObservationPhotos } from 'components/ObservationPhoto/components/NewObservationPhoto/NewObservationPhotos';
import { GoogleMapsApiKeyProvider } from 'modules/mapping';
import React from 'react';
import GoodPracticeReporter from 'sections/good-practice-management/pages/ViewAmendGoodPractice/components/GoodPracticeReporter';
import {
    StyledPanelGrid,
    StyledPanelRow,
    StyledPanelColumn,
    StyledContainer
} from 'shared/styled/panel.stayled';
import { ObservationFileEntity } from 'shared/types/file/ObservationFileEntity';
import { IAddFiles } from 'shared/utils/files/types/IAddFiles';

interface NewGoodPracticeForm {
    handleAddFile: IAddFiles<ObservationFileEntity>;
    handleDeleteFile: (ids: string[]) => void;
}

const NewGoodPracticeForm = ({
    handleAddFile,
    handleDeleteFile
}: NewGoodPracticeForm) => {

    return (
        <React.Fragment>
            <StyledContainer>
                <StyledPanelGrid fluid>
                    <StyledPanelRow>
                        <StyledPanelColumn md={12} lg={4} xl={4}>
                            <GoogleMapsApiKeyProvider>
                                <GoodPracticeCategorisation readOnly={false} />
                            </GoogleMapsApiKeyProvider>
                        </StyledPanelColumn>
                        <StyledPanelColumn md={12} lg={4} xl={4}>
                            <GoodPracticeDetails readOnly={false} />
                            <NewObservationPhotos handleAddFile={handleAddFile} handleDeleteFile={handleDeleteFile} />
                        </StyledPanelColumn>
                        <StyledPanelColumn md={12} lg={4} xl={4}>
                            <GoodPracticeReporter goodPracticeReadOnly={false} reporterReadOnly={false} />
                        </StyledPanelColumn>
                    </StyledPanelRow>
                </StyledPanelGrid>
            </StyledContainer>
        </React.Fragment>
    );
};

export default NewGoodPracticeForm;